import { isProd, isDev } from './env';
const useMock = isDev;
const bridge = {
    LMGetStatusBarHeight: () => window.AndroidWebView ? window.AndroidWebView.LMGetStatusBarHeight() || 44 : window.LMGetStatusBarHeight() || 44,
    CoreLPCloseDownRefresh: () => window.AndroidWebView ? window.AndroidWebView.LPCloseDownRefresh() : LPCloseDownRefresh(),
    CoreLMGetID1: () => new Promise((resolve, reject) => {
        let r;
        const client = isProd ? 'd9bc3ebda50f4132a6937dfdf8707a02' : '39b342e06405439c8d921b0b15a31980'; // 39测试 d9正式
        if (window.AndroidWebView) {
            r = window.AndroidWebView.LMGetID1(client);
            r = typeof r === 'string' ? JSON.parse(r) : r;
            resolve(r);
        } else {
            if (!!window.LMGetID1 && typeof window.LMGetID1 === 'function') {
                r = window.LMGetID1(client) || {};
                r = typeof r === 'string' ? JSON.parse(r) : r;
                resolve(r);
                return;
            }
            let count = 0;
            const timer = setInterval(function () {
                count++;
                if (count > 12) {
                    clearInterval(timer);
                    reject(count);
                }
                if (!!window.LMGetID1 && typeof window.LMGetID1 === 'function') {
                    r = window.LMGetID1(client) || {};
                    clearInterval(timer);
                    r = typeof r === 'string' ? JSON.parse(r) : r;
                    resolve(r);
                }
            }, 500);
        }
    }),
    LMSyncGetID1: () => {
        let r;
        const client = isProd ? 'd9bc3ebda50f4132a6937dfdf8707a02' : '39b342e06405439c8d921b0b15a31980';
        if (window.AndroidWebView) {
            r = window.AndroidWebView.LMGetID1(client);
        } else {
            r = window.LMGetID1(client) || {};
        }
        r = typeof r === 'string' ? JSON.parse(r) : r;
        return r;
    },
    // 重新刷token
    LPMRefreshToken: () => {
        const client = isProd ? 'd9bc3ebda50f4132a6937dfdf8707a02' : '39b342e06405439c8d921b0b15a31980';
        // HarmonyOS平台返回的就是一个Promise
        if (window.AndroidWebView && window.AndroidWebView.getPlatform && window.AndroidWebView.getPlatform() === 'HarmonyOS') {
            return window.AndroidWebView.LPMRefreshToken(client);
        }
        return new Promise((resolve) => {
            if (window.AndroidWebView) {
                resolve(window.AndroidWebView.LPMRefreshToken(client));
            } else {
                if (!!window.LPMRefreshToken && typeof window.LPMRefreshToken === 'function') {
                    resolve(window.LPMRefreshToken(client));
                }
            }
        });
    },
    CoreLMPushToURL: (...args) => {
        window.AndroidWebView ? window.AndroidWebView.LMPushToURL(...args) : LMPushToURL(...args);
    },
    CoreLMPopWebView: () => {
        window.AndroidWebView ? window.AndroidWebView.LMPopWebView() : LMPopWebView();
    },
    CoreLMShareURLtoSocialNet: (...args) => window.AndroidWebView ? window.AndroidWebView.LMShareURLtoSocialNet(...args) : LMShareURLtoSocialNet(...args),
    CoreLMGetID2: (...args) => window.AndroidWebView ? window.AndroidWebView.LMGetID2(...args) : LMGetID2(...args),
    // 打开原生相册支持图片及视频
    LPMOpenNativeNewPhotoPicker: obj => window.AndroidWebView ? window.AndroidWebView.LPMOpenNativeNewPhotoPicker(JSON.stringify(obj)) : window.LPMOpenNativeNewPhotoPicker(JSON.stringify(obj)),
    // 通过Url向原生获取缩略图
    LPMGetThumbImg: (obj) => {
        if (window.AndroidWebView && window.AndroidWebView.getPlatform && window.AndroidWebView.getPlatform() === 'HarmonyOS') {
            return window.AndroidWebView.LPMGetThumbImg(JSON.stringify(obj));
        }
        return new Promise(resolve => {
            if (window.AndroidWebView) {
                resolve(window.AndroidWebView.LPMGetThumbImg(JSON.stringify(obj)));
            } else {
                resolve(window.LPMGetThumbImg(JSON.stringify(obj)));
            }
        });
    }, 
    // 保存
    CoreLMSaveBase64Bitmap: obj => window.AndroidWebView ? window.AndroidWebView.LMSaveBase64Bitmap(JSON.stringify(obj)) : LMSaveBase64Bitmap(JSON.stringify(obj)),
    // 指定路径分享
    CoreLMShareURLtoChannel: obj => window.AndroidWebView ? window.AndroidWebView.LMShareURLtoChannel(JSON.stringify(obj)) : LMShareURLtoChannel(JSON.stringify(obj)),
    CoreCheck: (api) => {
        return new Promise((resolve) => {
            if (window.AndroidWebView) {
                resolve(!!window.AndroidWebView[String(api)]);
            } else {
                let count = 0;
                const timer = setInterval(function () {
                    count++;
                    if (count > 12) {
                        clearInterval(timer);
                        resolve(false);
                    }
                    if (!!window[String(api)] && typeof window[String(api)] === 'function') {
                        resolve(true);
                    }
                }, 500);
            }
        }).catch((e) => {
            console.log(e);
        });
    },
    // 获取APP通知开关状态
    CoreAppPushSwitchState: () => {
        if (
            window.AndroidWebView &&
            typeof window.AndroidWebView.AppPushSwitchState === 'function'
        ) {
            return window.AndroidWebView.AppPushSwitchState();
        } else if (typeof window.AppPushSwitchState === 'function') {
            return window.AppPushSwitchState();
        } else {
            return 'NotFoundCore';
        }
    },
    // 消息订阅
    LPMSubscribeToTopic: (data) => new Promise((resolve, reject) => {
        const jsonData = JSON.stringify(data);
        let r;
        if (window.AndroidWebView) {
            if (!window.AndroidWebView.LPMSubscribeToTopic) {
                reject(new Error());
            } else {
                r = window.AndroidWebView.LPMSubscribeToTopic(jsonData);
                r = typeof r === 'string' ? JSON.parse(r) : r;
                resolve(r);
            }
        } else {
            let count = 0;
            const timer = setInterval(function () {
                count++;
                if (count > 12) {
                    clearInterval(timer);
                    reject(count);
                }
                if (!!window.LPMSubscribeToTopic && typeof LPMSubscribeToTopic === 'function') {
                    r = window.LPMSubscribeToTopic(jsonData) || [];
                    clearInterval(timer);
                    r = typeof r === 'string' ? JSON.parse(r) : r;
                    resolve(r);
                }
            }, 500);
        }
    }),
    // 上传视频/图片至OSS
    LPMUploadImageOrVideoToOSS: obj => window.AndroidWebView ? window.AndroidWebView.LPMUploadImageOrVideoToOSS(JSON.stringify(obj)) : window.LPMUploadImageOrVideoToOSS(JSON.stringify(obj)),
};

const analogBridge = {
    LMGetStatusBarHeight: () => 44,
    LPMSubscribeToTopic: () => new Promise(() => { console.log('订阅消息'); }),
    CoreLPCloseDownRefresh: () => console.log('禁止下拉刷新调用成功'),
    CoreLMGetID1: () => Promise.resolve({
        LMPhoneNum: '13812345678', // '18100185420',
        LMAccID: '409086581652066304', // '1807601000169577',
        delegationToken: 'eddc4304-d03c-4478-add1-8fc9f2cdf5d6',
        APPToken: 'ED7643727495418B908227251D230C5AED7643727495418B908227251D230C5A'
    }),
    LMSyncGetID1: () => {
        return {
            LMPhoneNum: '13812345678',
            LMAccID: '409086581652066304', // '1807601000169577',
            delegationToken: 'eddc4304-d03c-4478-add1-8fc9f2cdf5d6',
            APPToken: 'ED7643727495418B908227251D230C5AED7643727495418B908227251D230C5A'
        };
    },
    LPMRefreshToken: () => {
        return new Promise(resolve => {
            resolve({
                LMPhoneNum: '18100185420', // '18100185420',
                LMAccID: '153735064750919680', // '1807601000169577',
                delegationToken: 'eddc4304-d03c-4478-add1-8fc9f2cdf5d6',
                APPToken: 'ED7643727495418B908227251D230C5AED7643727495418B908227251D230C5A'
            });
        });
    },
    CoreLMPushToURL (path) {
        /^([a-z][a-z\d+\-\\.]*:)?\/\//i.test(path) ? location.href = path
            : this.$router.push({
                path
            });
    },
    CoreLMPopWebView () {
        this.$router.back();
    },
    CoreLMShareURLtoSocialNet: () => {
        console.log('分享调用成功');
    },
    CoreLMGetID2: () => console.log('唤起APP登录弹窗'),
    CoreLMSaveBase64Bitmap: () => console.log('保存图片'),
    CoreLMShareURLtoChannel: obj => console.log('指定路径分享', obj),
    CoreAppPushSwitchState: obj => console.log('获取APP通知开关状态', obj),
    // 打开原生相册支持图片及视频
    LPMOpenNativeNewPhotoPicker: obj => console.log('打开原生相册支持图片及视频', obj),
    LPMGetThumbImg: obj => console.log('通过Url向原生获取缩略图', obj),
    CoreCheck: () => Promise.resolve(true),
    LPMUploadImageOrVideoToOSS: obj => console.log('上传视频/图片至OSS', obj),
};

const mobileCode = useMock ? analogBridge : bridge;
const {
    CoreLPCloseDownRefresh,
    CoreLMGetID1,
    LMSyncGetID1,
    LPMRefreshToken,
    CoreLMGetID2,
    CoreLMPushToURL,
    CoreLMPopWebView,
    CoreLMShareURLtoSocialNet,
    CoreLMSaveBase64Bitmap,
    CoreLMShareURLtoChannel,
    CoreCheck,
    LMGetStatusBarHeight,
    CoreAppPushSwitchState,
    LPMOpenNativeNewPhotoPicker,
    LPMGetThumbImg,
    LPMUploadImageOrVideoToOSS
} = mobileCode;
export {
    CoreLPCloseDownRefresh,
    CoreLMGetID1,
    LMSyncGetID1,
    LPMRefreshToken,
    CoreLMGetID2,
    CoreLMPushToURL,
    CoreLMPopWebView,
    CoreLMShareURLtoSocialNet,
    CoreLMSaveBase64Bitmap,
    CoreLMShareURLtoChannel,
    CoreCheck,
    LMGetStatusBarHeight,
    CoreAppPushSwitchState,
    LPMOpenNativeNewPhotoPicker,
    LPMGetThumbImg,
    LPMUploadImageOrVideoToOSS
};
